// A factsheet opened from a trip, in a new tab: the trip id travels in the
// URL, so the page knows its trip even when another one is open elsewhere.
export const tripFactsheetUrl = (path, { locale, tripId } = {}) => {
  const params = new URLSearchParams({ source: 'trip' });
  if (locale) params.set('locale', locale);
  if (tripId) params.set('tripId', tripId);
  return `${path}?${params}`;
};
